import { render, staticRenderFns } from "./openLabour.vue?vue&type=template&id=21daaa26&scoped=true&"
import script from "./openLabour.vue?vue&type=script&lang=js&"
export * from "./openLabour.vue?vue&type=script&lang=js&"
import style0 from "./openLabour.vue?vue&type=style&index=0&id=21daaa26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21daaa26",
  null
  
)

export default component.exports